import ChangePasswordForm from 'forms/ChangePasswordForm'
import { useInfoProviderContext } from 'utils/providers/InfoProvider/InfoProviderContext'

import { serverSideTranslations } from 'next-i18next/serverSideTranslations'
import dynamic from 'next/dynamic'
import Head from 'next/head'
import { useRouter } from 'next/router'

import AuthLayout from 'layouts/AuthLayout'

import Typography from 'components/Typography'

import styles from './changePassword.module.scss'

const DynamicRestrictedModal = dynamic(() => import('components/RestrictedModal'))

const ChangePassword = ({ referrer }: { referrer: string }) => {
  const router = useRouter()
  const token = router.query.recovery_confirm_token

  const info = useInfoProviderContext()

  if (info?.restricted === true) {
    return <DynamicRestrictedModal />
  }
  return (
    <>
      <Head>
        <title>Change Password | Binany</title>
        <meta name="description" content="Change Password" />
      </Head>

      <AuthLayout>
        <div className={styles.grid}>
          <Typography variant="h4" className={styles.header}>
            Change password
          </Typography>
          <ChangePasswordForm referrer={referrer} token={token} />
        </div>
      </AuthLayout>
    </>
  )
}

export default ChangePassword

export async function getServerSideProps({ locale }) {
  return {
    props: {
      ...(await serverSideTranslations(locale, ['main', 'contacts', 'shared', 'error'])),
    },
  }
}
